import { alpha } from '@mui/material';
const useQuestionCardStyles = () => {
    return {
        main: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            borderRadius: '14px',
            rowGap: 8,
            py: 1.5,
            pl: 4,
            pr: 2,
            gap: 1,
            backgroundColor: (theme) => 'transparent',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            mb: 1,
            ml: 2,
            gap: 1,
            flexWrap: 'wrap'
            // backgroundColor: (theme) => theme.palette.grey[50],
            // border: (theme) => `1px solid ${theme.palette.grey[300]}`,
            // borderRadius: 2,
            // padding: 1.5,
        },
        toolbarSection: {
            display: 'flex',
            gap: 1
        },
        fieldContainer: {
            display: 'flex',
            flexDirection: 'column',
            // backgroundColor: (theme) => theme.palette.common.white,
            // borderRadius: 1,
            // border: (theme) => `1px solid ${theme.palette.grey[300]}`,
            // p: 2,
            // minHeight: 48
            ml: 2
        },
        dragIndicatorContainer: {
            position: 'absolute',
            left: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 24,
            height: 24,
            borderRadius: '4px'
        },
        label: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: 28 / 16,
            textAlign: 'center',
            color: (theme) => theme.palette.grey[700]
        },
        field: {}
    };
};
export default useQuestionCardStyles;
